import { getColor } from '@/utils/theme/colors';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import React from 'react';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SwiperButton from '@/assets/pdp/offerSwiperButton.svg';

import { ICarousel } from '../model';
import { Lazy, Navigation, Pagination } from 'swiper';

const CustomDiv = styled(Box)`
max-width:1440px;
width:100%;
position:relative;
.LencoSwiper .swiper{
    position:relative;

}
.LencoSwiper .swiper-pagination {
    text-align:left;

    padding-top:8px;
}

.LencoSwiper .swiper-wrapper{
    padding-bottom:30px;
		padding-top:4px;
	}

.LencoSwiper .swiper-slide{
    border-radius:8px;
}

.LencoSwiper .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    display: inline-block;
    background: ${getColor('Gray 0')};
    opacity: .1;
    margin: 0 5px;
    -webkit-border-radius: 20px;
            border-radius: 20px;
    -webkit-transition: opacity .5s, background-color .5s, width .5s;
    -o-transition: opacity .5s, background-color .5s, width .5s;
    transition: opacity .5s, background-color .5s, width .5s;
    -webkit-transition-delay: .5s, .5s, 0s;
         -o-transition-delay: .5s, .5s, 0s;
            transition-delay: .5s, .5s, 0s;
    }        
}
.LencoSwiper .swiper-pagination-clickable .swiper-pagination-bullet {
    cursor: pointer;
}
.LencoSwiper .swiper-pagination .swiper-pagination-bullet-active {
    opacity:0.3;
    background: ${getColor('Gray 0')};
    width: 30px;
    -webkit-transition-delay: 0s;
         -o-transition-delay: 0s;
            transition-delay: 0s;
}  
`;

const DesignFeatureCarousel = (props: ICarousel) => {
	const swiperRef = React.useRef<SwiperRef>(null);
	return (
		<CustomDiv>
			{swiperRef && (
				<Box
					onClick={(e) => {
						e.stopPropagation();
						swiperRef?.current?.swiper?.slidePrev();
					}}
					sx={{
						transform: 'rotate(180deg)',
						position: 'absolute',
						zIndex: 9,
						top: '30%',
						left: '-25px',
						tranform: 'translate(-50%)',
						cursor: 'pointer',
					}}
				>
					<SwiperButton />
				</Box>
			)}

			<Swiper
				ref={swiperRef}
				modules={[Navigation, Lazy, Pagination]}
				className='LencoSwiper'
				loop={true}
				spaceBetween={props.spaceBetween}
				slidesPerView={props.slidesPerView}
				pagination={props.dots}
				centeredSlides={props?.centered}
			>
				{props?.children?.map((d, index) => {
					return <SwiperSlide key={index}>{d}</SwiperSlide>;
				})}
			</Swiper>
			{swiperRef && (
				<Box
					id='nextButton'
					onClick={(e) => {
						e.stopPropagation();
						swiperRef?.current?.swiper?.slideNext();
					}}
					sx={{
						position: 'absolute',
						tranform: 'translate(-50%)',
						zIndex: 9,
						top: '35%',
						right: '-25px',
						cursor: 'pointer',
					}}
				>
					<SwiperButton />
				</Box>
			)}
		</CustomDiv>
	);
};

export default DesignFeatureCarousel;
